import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { ApplicationWrapper } from 'containers/ApplicationWrapper';
import { CookiesProvider } from 'react-cookie';
import Cookies from 'universal-cookie';
import { OptimizelyProvider } from '@optimizely/react-sdk';

Bugsnag.start({
	apiKey: process.env.BUGSNAG_CLIENT_KEY,
	plugins: [new BugsnagPluginReact()],
});

const ErrorBoundary = Bugsnag.getPlugin('react').createErrorBoundary(React);

import '../main.scss';

export const App = ({
	store,
	optimizelyClient = null,
	optimizelyUser = null,
}) => {
	const cookies = useMemo(() => new Cookies(), []);
	const visitId = store.getState()?.user?.visitId;
	const user = optimizelyUser || { id: visitId };
	const appTree = (
		<ErrorBoundary>
			<CookiesProvider cookies={cookies}>
				<BrowserRouter
					future={{
						v7_startTransition: true,
						v7_relativeSplatPath: true,
					}}
				>
					<ApplicationWrapper />
				</BrowserRouter>
			</CookiesProvider>
		</ErrorBoundary>
	);

	return (
		<Provider store={store}>
			{optimizelyClient ? (
				<OptimizelyProvider
					optimizely={optimizelyClient}
					user={user}
				>
					{appTree}
				</OptimizelyProvider>
			) : (
				appTree
			)}
		</Provider>
	);
};

App.propTypes = {
	store: PropTypes.object,
	optimizelyClient: PropTypes.object,
	optimizelyUser: PropTypes.shape({
		id: PropTypes.string,
		attributes: PropTypes.object,
	}),
};

export default App;
